import { render } from "./IconCheck.vue?vue&type=template&id=36430622"
const script = {}

import exportComponent from "C:\\Projects\\wordpress\\zens\\wp-content\\themes\\io.corporate-zens-adventkalender\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__